import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Chatbox from "../layout/common/Chatbox";
import Footer from "../layout/common/Footer";
import Header from "../layout/common/Header";
import NavHeader from "../layout/common/NavHeader";
import NewSidebar from "../layout/common/NewSidebar";
import Sidebar from "../layout/common/Sidebar";
import SidebarTest from "../layout/common/SidebarTest";
import ContentBody from "../layout/user/ContentBody";

const Users = () => {
  const [pageNumber, setPageNumber] = useState(0);
  const [sortBy, setSortBy] = useState("createdDate");
  const [sortType, setSortType] = useState(true);
  const [userListData, setUserListData] = useState([]);
  const [statusRecord, setStatusRecord] = useState(false);
  const [perPageRecords, setPerPageRecords] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [statusChange, setStatusChange] = useState(null);
  const [userOnMainPage, setUserOnMainPage] = useState(null);

  // server side pagination
  const onChangePageNumberHandler = (e) => {
    setPageNumber(e);
  };

  const sortOnClickHandler = (e) => {
    setSortBy(e);
  };

  const sortTypeOnClickHandler = (e) => {
    setSortType(e);
  };

  const onStatusRecordChangeHandler = (val) => {
    setStatusRecord(!statusRecord);
  };

  const pageChange = (val) => {
    setPerPageRecords(val);
  };

  const searchValueChange = (val) => {
    setSearchValue(val);
  };

  let pageCount = 0;
  if (userListData && userListData.totalUsers && userListData.totalUsers > 0) {
    pageCount = Math.ceil(userListData.totalUsers / perPageRecords);
  }

  useEffect(() => {
    const query = {
      sortby: sortBy,
      sorttype: sortType,
      perpage: perPageRecords,
      currentpage: pageNumber + 1,
      search: searchValue,
      statusChange: statusChange,
    };
    (async () => {
      const data = await fetch(process.env.REACT_APP_API_URL +"user-listing", {
        method: "POST",
        body: JSON.stringify(query),
        headers: {
          "Content-type": "application/json",
        },
      });
      const response = await data.json();
      setUserListData(response);
    })();
  }, [
    pageNumber,
    sortBy,
    statusRecord,
    perPageRecords,
    searchValue,
    sortType,
    statusChange,
    userOnMainPage,
  ]);

  const statusChangeHandler = (e) => {
    setStatusChange(e);
  };

  const showUserOnMainPageHandler = (val) => {
    setUserOnMainPage(val);
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Users</title>
      </Helmet>
      <NavHeader />
      <Header />
      <SidebarTest />
      <ContentBody
        userList={userListData}
        pageNumber={pageNumber}
        onChangePageNumber={onChangePageNumberHandler}
        usersPerPage={perPageRecords}
        pageCount={pageCount}
        onChangeSortClick={sortOnClickHandler}
        onChangeSortType={sortTypeOnClickHandler}
        onStatusRecordChange={onStatusRecordChangeHandler}
        onSearchChang={searchValueChange}
        onPerPageChange={pageChange}
        onChangeStatus={statusChangeHandler}
        statusChange={statusChange}
        onShowUserOnMainPage={showUserOnMainPageHandler}
      />
      <Footer />
    </React.Fragment>
  );
};
export default Users;
